<template>
  <div id="detail">
    <div slot="table-busy" class="text-center text-gold my-2" v-if="isBusy">
      <b-spinner class="align-middle"></b-spinner>
      <strong>{{$t("Chargement")}} ...</strong>
    </div>
    <div v-if="!isBusy">
      <div class="row mb-4">
        <div class="col-md-7">
          <EvaluationSumLine v-model="datas" :rights="rights"></EvaluationSumLine>
        </div>
        <div class="col-md-5 text-right pt-3">
          <a href="javascript:void(0)" @click="rapport_get()" class="btn btn-gold xs" right :disabled="!this.datas.hasRapport" v-if="rights.see_rapport"><span v-if="this.datas.hasRapport">{{$t("Télécharger le rapport")}}</span><span v-else>{{$t("Rapport en cours de génération")}} <b-spinner class="align-middle"></b-spinner></span></a>
          <a href="javascript:void(0)" @click="facture_get()" class="btn btn-gold xs ml-3" right v-if="this.datas.trans==3 && rights.see_facture">{{$t("Télécharger la facture")}}</a> 
        </div>
      </div>
      <b-tabs nav-wrapper-class="bg-dark ooftop-tabs" align="center" v-model="tabs">
        <b-tab lazy v-if="rights.rapport.synthese" :title="$t('Synthèse')">
          <div class="noverflow">
            <EvaluationStreetview v-model="datas" :gmapkey="gmap_key" :rights="rights" @enregSuccess="enregSuccess" @enregFailed="enregFailed"></EvaluationStreetview>
            <div v-if="datas.trames.length && rights.rapport.trames" class="bg-gold tramesResult mt-2">
                <h2 class="bold mt-5 bigText2" style="font-size:1.6em;"><i class="icon-user2" style="font-size:30px;top:3px;position:relative;"></i> {{$t("L'analyse de l'évaluateur Ooftop")}}</h2>
                <div v-for="(trame,idt) in datas.trames" :key="'trame_'+idt">
                  <h3 class="bold mt-5 bigText2">
                    <i class="icon-price-100" v-if="trame.id==6"></i>
                    <i class="icon-report-card-128" v-if="trame.id==2"></i>
                    <i class="icon-real-estate-64" v-if="trame.id==1"></i> {{$t(trame.label.replace('du marche','du marché'))}}
                  </h3>
                  <div class="quote"><i class="fas fa-quote-left"></i><span v-html="trame.content"></span><i class="fas fa-quote-right"></i></div>
                </div>
            </div>
            <EvaluationPF v-model="datas" :ooftopMapApi="ooftopMapApi" :ooftopMapApiKey="ooftopMapApiKey" :rights="rights" v-if="rights.rapport.synthese_pf" :color="partner.code=='BNPPF'?'rgb(23, 150, 104)':'rgb(234, 100, 84)'"></EvaluationPF>
            <b-form @submit="submit_ea" class="d-block forms" v-if="infos_cli.droits_expert=='nat_ei' || infos_cli.droits_expert=='nat_admin' || infos_cli.droits_expert=='nat_super_admin'">
              <div id="expertise">
                <h3 class="bold mt-5 bigText2"><i class="icon-star-100"></i> {{$t("Analyse expert")}}</h3>
                <div class="row">
                  <div v-for="(emplacement,ide) in emplacements" :key="'emplacement_'+ide" :class="'col-md-'+(ide==3?'12':'6')">
                    <div class="bg-blue mt-2">
                      <h4 class="bold mt-1 bigText2">{{$t(emplacement.label)}}</h4>
                      <p v-if="ide==3">Prix de l'évaluation : <b class="hight">{{$t("$")}} {{format_number(datas.estimation)}} {{$t("€")}}</b></p>
                      <div class="valeurs">
                        <ul class="nolist">
                          <li v-for="(valeur,idv) in emplacement.valeurs" :key="'valeur_'+emplacement.id+'_'+idv">
                            <b-form-group :id="'valeur_'+emplacement.id+'_'+idv" class="light size-part size-part-auto">
                                <template slot="label">{{$t(valeur.label)}}<a class='resetRadio' href='javascript:void(0)' @click="valeur.selected=0">{{$t("Réinitialiser le champs")}}</a></template>
                                <b-form-radio-group buttons :options="valeur.options" v-model='valeur.selected'></b-form-radio-group>
                            </b-form-group>
                          </li>
                        </ul>
                      </div>
                      <div class="childs">
                        <div v-for="(emplacementc,idec) in emplacement.childs" :key="'emplacement_'+idec">
                          <div v-if="idec==(emplacement.valeurs[Object.keys(emplacement.valeurs)[0]].selected-37)">
                            <h4 class="bold mt-1 bigText2">{{$t(emplacementc.label)}}</h4>
                            <div class="valeurs">
                              <ul class="nolist">
                                <li v-for="(valeur,idv) in emplacementc.valeurs" :key="'valeur_'+emplacementc.id+'_'+idv">
                                  <b-form-group :id="'valeur_'+emplacementc.id+'_'+idv" class="light size-part size-part-auto">
                                      <template slot="label">{{$t(valeur.label)}}<a class='resetRadio' href='javascript:void(0)' @click="valeur.selected=0;">{{$t("Réinitialiser le champs")}}</a></template>
                                      <b-form-radio-group buttons :options="valeur.options" v-model='valeur.selected' @click="check_btn_action(ide,valeur.selected,emplacement)"></b-form-radio-group>
                                  </b-form-group>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div v-if="ide==3 && emplacement.valeurs[Object.keys(emplacement.valeurs)[0]].selected==50">
                        <b-form-group :label="$t('Prix fixe')" :label-for="'emplacement_prix_fixe_'+ide">
                            <b-form-input :id="'emplacement_prix_fixe_'+ide" v-model='emplacement.prix_fixe' v-mask="mask" class="numCheck"></b-form-input>
                        </b-form-group>
                        <b-form-group :label="$t('Fourchette')" :label-for="'emplacement_prix_fourchette_'+ide">
                          <div class="container">
                            <div class="row">
                              <div class="col-md-1">De </div>
                              <b-form-input :id="'emplacement_prix_fourchette_de_'+ide" v-model='emplacement.fourchette_de' v-mask="mask" class="numCheck col-md-5"></b-form-input> 
                              <div class="col-md-1">à </div>
                              <b-form-input :id="'emplacement_prix_fourchette_a_'+ide" v-model='emplacement.fourchette_a' v-mask="mask" class="numCheck col-md-5"></b-form-input>
                            </div>
                          </div>
                        </b-form-group>
                      </div>
                      <b-form-group :label="$t('Champ libre')" :label-for="'emplacement_com_'+ide">
                        <b-form-textarea :id="'emplacement_com_'+ide" v-model="emplacement.commentaires" placeholder="" rows="7" max-rows="7"  maxlength="900"></b-form-textarea>
                      </b-form-group>
                    </div>
                  </div>
                </div>  
              </div>
              <button type="button" class="btn btn-gold mt-5 mr-2" @click="open_submit_ea()" v-if="datas.etr_step==0">{{$t("Valider")}}</button>
              <button type="button" class="btn btn-gold mt-5 mr-2" @click="open_submit_ea()" v-if="datas.etr_step==1 && (infos_cli.droits_expert=='nat_admin' || infos_cli.droits_expert=='nat_super_admin')">{{$t("Valider definitivement")}}</button>
              <button v-if="(infos_cli.droits_expert=='nat_admin' || infos_cli.droits_expert=='nat_super_admin') && datas.etr_step>0" type="button" class="btn btn-secondary mt-5" @click="open_return_ea()">{{$t("Retourner")}}</button>
            </b-form>
          </div>
        </b-tab>
        <b-tab lazy v-if="rights.rapport.eval_prix" :title="$t('Evaluations prix')">
          <EvaluationPrix v-model="datas" :gmapkey="gmap_key" :rights="rights"></EvaluationPrix>
        </b-tab>
        <b-tab lazy  :title="$t('Bien vendus')">
          <EvaluationTransactions v-if="rights.rapport.marche_immo && rights.rapport.marche_immo_bien_vendus" v-model="datas" :ooftopMapApi="ooftopMapApi" :ooftopMapApiKey="ooftopMapApiKey" :rights="rights" @enregSuccess="enregSuccess" @enregFailed="enregFailed"></EvaluationTransactions>
        </b-tab>
        <b-tab lazy v-if="rights.rapport.quartier" :title="$t('Le quartier')">
          <EvaluationQuartier v-model="datas" :rights="rights" :ooftopMapApi="ooftopMapApi" :ooftopMapApiKey="ooftopMapApiKey"></EvaluationQuartier>
        </b-tab>
        <b-tab lazy v-if="rights.rapport.risques" :title="$t('Risques')">
          <EvaluationRisques v-model="datas" :rights="rights" :ooftopMapApi="ooftopMapApi" :ooftopMapApiKey="ooftopMapApiKey"></EvaluationRisques>
        </b-tab>
      </b-tabs>
    </div>
    <b-modal id="modal-submitEA" title="Confirmation" hide-footer>
      <p class="my-4">{{$t("Êtes vous sur de vouloir valider cette expertise ? Une fois validée aucune modification ne peut être faite")}}</p>
      <p>
        <button type="button" class="btn btn-gold mr-2" @click="submit_ea()"><span v-if="!axiosInProgress">{{$t("Valider")}}</span><span v-else>{{$t("En cours ... ")}} <b-spinner class="align-middle"></b-spinner></span></button>
        <button type="button" class="btn btn-dark mr-2" @click="$bvModal.hide('modal-submitEA')">{{$t("Annuler")}}</button>
      </p>
    </b-modal>
    <b-modal id="modal-retournerEA" title="Confirmation" hide-footer>
      <p class="my-4">{{$t("Êtes vous sur de retourner cette expertise ?")}}</p>
      <b-form-group :label="$t('Commentaire interne')" label-for='commentaire_interne'>
        <b-form-textarea id='commentaire_interne' v-model="commentaire_interne" placeholder="" rows="7" max-rows="7"  maxlength="3999"></b-form-textarea>
      </b-form-group>
      <p>
        <button type="button" class="btn btn-secondary mr-2" @click="return_ea()"><span v-if="!axiosInProgress">{{$t("Retourner")}}</span><span v-else>{{$t("En cours ... ")}} <b-spinner class="align-middle"></b-spinner></span></button>
        <button type="button" class="btn btn-dark mr-2" @click="$bvModal.hide('modal-retournerEA')">{{$t("Annuler")}}</button>
      </p>
    </b-modal>
    <b-modal id="modal-error" title="Information" hide-footer>
      <p class="my-4">{{$t("Pour les emplacements suivants, merci de remplir le champs libre ou toutes les questions :")}}</p>
      <ul>
        <li v-for="(error,ider) in errors" :key="ider">{{error}}</li>
      </ul>
    </b-modal>
  </div>
</template>

<script>
  import 'jquery';
  import axios from "axios";
  import VueInputMask from 'v-mask';
  import createNumberMask from 'text-mask-addons/dist/createNumberMask';
  import $Scriptjs from 'scriptjs';
  import EvaluationPrix from '@/components/Evaluations/EvaluationPrix'
  import EvaluationSumLine from '@/components/Evaluations/EvaluationSumLine'
  import EvaluationTransactions from '@/components/Evaluations/EvaluationTransactions'
  import EvaluationQuartier from '@/components/Evaluations/EvaluationQuartier'
  import EvaluationRisques from '@/components/Evaluations/EvaluationRisques'
  import EvaluationStreetview from '@/components/Evaluations/EvaluationStreetview'
  import EvaluationPF from '@/components/Evaluations/EvaluationPF'
  const currencyMask = createNumberMask({
    prefix: '',
    allowDecimal: true,
    includeThousandsSeparator: true,
    thousandsSeparatorSymbol: ' ',
    allowNegative: false,
  });
  export default {
    components: { VueInputMask,EvaluationPrix,EvaluationSumLine,EvaluationTransactions,EvaluationQuartier,EvaluationRisques,EvaluationStreetview,EvaluationPF },
    data() {
      return {
        mask: currencyMask,
        isBusy: true,
        tabs:0,
        axiosInProgress:false,
        hasRapport: false,
        nodata:this.$i18n.t('Données insuffisantes'),
        gmap_key:'AIzaSyDGc_oBNLZF6jhV6OmZxDArFxAnPgPOmA0',
        ooftopMapApi:'',
        ooftopMapApiKey:'',
        commentaire_interne:'',
        rights:[],
        errors:[],
        emplacements:[],
        datas:{},
      };
    },
    methods:{
      enregSuccess(message){
        this.load_dossier(0);
        this.infosModal('success',message,false,'Confirmation');
      },
      enregFailed(message){
        this.infosModal('warning',message,false,'Informations');
      },
      rapport_get() {
        if(!this.datas.hasRapport)this.infosModal("warning", this.$i18n.t("Le téléchargement du rapport en pdf est indisponible pour le moment. Veuillez nous excuser pour la gêne occasionnée"), false, 'Informations');
        else window.open(this.$apiUrl+"demandes/rapport/"+this.idpage+"?lang="+this.$i18n.locale+"&auth="+JSON.stringify(this.auth_header()));
      },
      facture_get(){
        window.open(this.$apiUrl+'demandes/getDoc/facture/'+this.datas.id+'?auth='+JSON.stringify(this.auth_header()));
      },
      open_submit_ea(){
        this.$bvModal.show("modal-submitEA");
        return false;
      },
      open_return_ea(){
        this.$bvModal.show("modal-retournerEA");
        return false;
      },
      return_ea(){
        var p=this;
        if(this.commentaire_interne=='')alert("Merci de remplir le commentaire interne");
        else{
          this.axiosInProgress=true;
          axios.get(p.$apiUrl+"demandes/rework_expert/"+this.datas.id+"?lang="+this.$i18n.locale+"&commentaire_interne="+this.commentaire_interne+"&auth="+JSON.stringify(p.auth_header())).then(function(response){
              if(response.data.error=='notlogged'){
                  p.logout();
                  p.$router.push({ path: '/' });
              }
              if (response.data.success) {
                  p.$bvModal.hide("modal-retournerEA");
                  p.load_dossier(0);
                  p.infosModal('success',response.data.success,false,'Confirmation');
              } else {
                  if(response.data.error!="")p.infosModal('warning',response.data.error,false,'Informations');
              }
              p.loading = false;
              p.axiosInProgress=false;
          }).catch(function(error){
              p.loading = false;
              p.axiosInProgress=false;
          });
        }
        return false;
      },
      submit_ea(){
        this.errors=[];
        for(var ide in this.emplacements){
          if(this.emplacements[ide].commentaires==''){
            for(var idv in this.emplacements[ide].valeurs){
              if(!this.emplacements[ide].valeurs[idv].selected){
                this.errors.push(this.emplacements[ide].label);
                break;
              }
            }
          }
        }
        if(this.emplacements[3].commentaires=="" && this.emplacements[3].valeurs[11].selected==50)this.errors.push("Le commentaire est obligatoire lors d'un changement de prix");
        if(this.emplacements[3].fourchette_de>this.emplacements[3].fourchette_a)this.errors.push("La fourchette de prix n'est pas cohérente");
        if(this.errors.length)this.$bvModal.show("modal-error");
        else{
          this.loading=true;
          this.axiosInProgress=true;
          var p=this;
          let formData = new FormData();
          formData.append('datas', JSON.stringify(p.emplacements));
          axios.post(p.$apiUrl+"demandes/expertise/"+this.datas.id+"?lang="+this.$i18n.locale+"&auth="+JSON.stringify(p.auth_header()),formData,{headers: {'Content-Type': 'multipart/form-data'}}).then(function(response){
              if(response.data.error=='notlogged'){
                  p.logout();
                  p.$router.push({ path: '/' });
              }
              if (response.data.success) {
                  p.$bvModal.hide('modal-submitEA');
                  p.load_dossier(0);
                  p.infosModal('success',response.data.success,false,'Confirmation');
                  if(response.data.id_ext)axios.get(p.$apiUrl+"demandes/rapport/"+p.idpage+"?lang="+p.$i18n.locale+"&generate=1&copy=natimmo_"+response.data.id_ext+"&auth="+JSON.stringify(p.auth_header())).then(response => {p.datas.hasRapport=true;})
              } else {
                  if(response.data.error!="")p.infosModal('warning',response.data.error,false,'Informations');
              }
              p.loading = false;
              p.axiosInProgress=false;
          }).catch(function(error){
              p.loading = false;
              p.axiosInProgress=false;
          });
        }
      },
      load_dossier(generate){
        var p=this;
        var headerAx={};
        if(this.tokenExpert)headerAx={params : {tokenExpert:this.tokenExpert,lang:this.$i18n.locale}};
        else headerAx={params : {auth:this.auth_header(),lang:this.$i18n.locale}};
        axios.get(this.$apiUrl+"demandes/detail/"+this.idpage ,headerAx).then(response => {
          if(this.tokenExpert && response.data.error!=''){
            document.getElementById('app').innerHTML="<div class='errorBig'>"+response.data.error+"</div>";
          }
          if(response.data.error=='notlogged'){
            this.logout();
            this.$router.push({ path: '/' });
          }
          else{
            if (response.data.datas) {
              if(this.tokenExpert && response.data.client){
                this.set_current_user(response.data.client);
                this.get_infos_cli();
              }
              this.datas = response.data.datas;
              this.emplacements = response.data.emplacements;
              this.rights = response.data.right;
              this.ooftopMapApiKey = (response.data['ooftop-token'] || {}).token || '';
              this.isBusy=false;
              if(this.datas.code_postal.substring(0,2)=='58' || this.datas.code_postal.substring(0,2)=='67' || this.datas.code_postal.substring(0,2)=='68')this.nodata='pour ce département les données ne sont pas disponibles';
              if(generate)axios.get(this.$apiUrl+"demandes/rapport/"+this.idpage+"?lang="+this.$i18n.locale+"&generate=1&auth="+JSON.stringify(this.auth_header())).then(response => {this.datas.hasRapport=true;})
            
              $Scriptjs('https://maps.googleapis.com/maps/api/js?key='+p.gmap_key+'&callback=Function.prototype', () => {
              });
            } else {
                this.show_alert("warning","Pas de données disponible");
            }
          }
        }).catch(error => {});
      }
    },
    watch: {
      emplacements: {
          handler: function(newValue) {
              if(newValue[3].valeurs[11].selected==51)this.emplacements[3].commentaires='Valeur non modifiée par l’évaluateur';
          },
          deep: true
      },
    },
    mounted() {
      var p=this;
      this.idpage = this.$route.params.id;
      this.tokenExpert = this.$route.params.token;
      this.ooftopMapApi=this.$apiOoftopUrl;
      this.load_dossier(1);
    },
  };
</script>
